export default __webpack_public_path__ + "static/media/d5f40c50a8575ce3.649b7c23e8f8b3fde247bd9d50ab4f0e.svg";